import { colors } from '@lmc/common/constants'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { ChartLogList } from '../../../../components/generic'
import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import Highcharts from './Highcharts'

class FoodChart extends Component {
  formatSeriesData(data) {
    // transform the logs into a format expected by highcharts
    return _.chain(data)
      .filter((d) => !d.deleted)
      .groupBy((log) =>
        dayjs(log.timeLogged).startOf('day').add(1, 'h').format()
      )
      .map((value, date) => {
        const total = _.chain(value)
          .map(`measurements.meal.value`)
          .filter(_.isNumber) // triggers error for non numeric values
          .sum()
          .value()

        return [Date.parse(dayjs(date).toString()), total] // { x: date, y: total };
      })
      .value()
  }

  render() {
    const { logs } = this.props
    let series = [
      {
        name: 'Pudding',
        pattern: /pudding/i,
        color: colors.darkgrey,
        logs: []
      },
      {
        name: 'Snack',
        pattern: /snack/i,
        color: colors.grey,
        logs: []
      },
      {
        name: 'Dinner',
        pattern: /dinner/i,
        color: colors.pink,
        logs: []
      },
      {
        name: 'Lunch',
        pattern: /lunch/i,
        color: colors.pink,
        logs: []
      },
      {
        name: 'Breakfast',
        pattern: /breakfast/i,
        color: colors.palerose,
        logs: []
      }
    ]

    const otherSeries = {
      name: 'Other',
      color: colors.mulberry,
      logs: []
    }

    // Add each log to the series by matching the title
    // The app generates titles, so they're predictable
    // The title is user generated when adding it in the CO
    // so we add it to Other
    logs?.forEach((log) => {
      let matched = false
      series.forEach((row) => {
        if (
          log.title.match(row.pattern) ||
          (log.description && log.description.match(row.pattern))
        ) {
          row.logs.push(log)
          matched = true
        }
      })
      if (!matched) otherSeries.logs.push(log)
    })

    series = [otherSeries, ...series]
    series = series.map(({ logs, ...row }) => ({
      ...row,
      data: this.formatSeriesData(logs)
    }))

    const config = {
      title: chartTitles.meal,
      yAxisLabel: 'Portions Consumed',
      yMax: 6,
      legendEnabled: true,
      chartType: 'column',
      series,
      plotOptions: {
        turboThreshold: 10000
      }
    }

    return logs && logs.length ? (
      <div>
        <Highcharts config={config} />
        <ChartLogList logs={logs} />
      </div>
    ) : (
      <EmptyState
        title="Shoot... No data to show you"
        description="No logs to display"
        icon={<NoDataIcon />}
      />
    )
  }
}

FoodChart.propTypes = {
  logs: PropTypes.array
}

export default withToolbar(FoodChart, {
  pdfExport: {
    title: 'Food Chart'
  },
  timeWindow: 7 * 4
})
